<script setup>
    import { WrenchScrewdriverIcon } from '@heroicons/vue/24/outline';

</script>

<template>
    <div class="grid min-h-screen place-items-center bg-white px-6 lg:px-8">
        <div class="text-center mb-24">
            <p class="text-base font-semibold text-rose-600 text-center">
                <WrenchScrewdriverIcon class="w-8 h-8 mx-auto"/>
            </p>
            <h1 class="mt-4 text-3xl font-bold tracking-tight text-gray-900 sm:text-5xl">Page en construction...</h1>
        </div>
    </div>
</template>